<template>
  <div v-if="loading">加载中...</div>
  <div v-else>
    <b>节点列表：</b>
    <table>
      <thead><tr><th>ID</th><th>SiteName</th></tr></thead>
      <tbody>
        <tr v-for="node in safeNodesWithLog" :key="node.id">
          <td>{{ node.id }}</td>
          <td>{{ node.siteName }}</td>
        </tr>
        <tr v-if="safeNodesWithLog.length === 0"><td colspan="2">暂无节点</td></tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { getUserNodes } from '@/services/apiService';
export default {
  props: ['userId'],
  data() { return { nodes: [], loading: true }; },
  computed: {
    safeNodesWithLog() {
      const arr = Array.isArray(this.nodes)
        ? this.nodes.filter(n => n && typeof n === 'object' && n.id !== undefined && n.id !== null && n.id !== '' && n.siteName)
        : [];
      console.log('UserNodeTable safeNodes:', arr, 'raw nodes:', this.nodes);
      return arr;
    }
  },
  async mounted() {
    console.log('UserNodeTable mounted, userId:', this.userId);
    if (!this.userId) {
      this.loading = false;
      return;
    }
    try {
      const authStore = require('@/stores/userStore').useAuthStore();
      const token = authStore.token;
      this.nodes = await getUserNodes(this.userId, token);
      console.log('Fetched nodes:', this.nodes);
    } catch (e) {
      this.nodes = [];
    } finally {
      this.loading = false;
    }
  }
};
</script> 